
const isLoggedIn = () => {
    const loggedIn = Boolean(localStorage.getItem("token"));
    return loggedIn
};

export default isLoggedIn